export default {
      id: "Icon--bins-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--bins",
      toString: function () {
        return this.url;
      }
    }